"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteDuplicates = exports.remove = exports.save = exports.load = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
/**
 * @depreacated
 * Use `@kiwicom/cookies`
 */
const load = key => {
  var _JsCookie$get;
  return (_JsCookie$get = _jsCookie.default.get(key)) !== null && _JsCookie$get !== void 0 ? _JsCookie$get : null;
};

/**
 * @depreacated
 * Use `@kiwicom/cookies`
 */
exports.load = load;
const save = (key, value, opts) => {
  _jsCookie.default.set(key, value, opts);
};

/**
 * @depreacated
 * Use `@kiwicom/cookies`
 */
exports.save = save;
const remove = (key, opts) => {
  _jsCookie.default.remove(key, opts);
};
exports.remove = remove;
const deleteDuplicates = domain => {
  document.cookie.split("; ").map(item => item.split("=")[0]).filter((val, i, arr) => arr.indexOf(val) !== i).forEach(cookie => _jsCookie.default.remove(cookie, {
    domain
  }));
};
exports.deleteDuplicates = deleteDuplicates;